import { useQuery } from "react-query";

export type Referrer = { code: string; username: string; avatar?: string };

// Who owns a referral code: undefined while loading, null for an unknown
// code or none given.
export function useReferrer(code: string | null | undefined) {
  const { data } = useQuery(
    ["referrer", code],
    async (): Promise<Referrer | null> => {
      const res = await fetch(
        `/api/referral/lookup?code=${encodeURIComponent(code!)}`,
      );
      if (!res.ok) return null;
      const d = await res.json();
      return d?.found
        ? { code: d.code, username: d.username, avatar: d.avatar }
        : null;
    },
    { enabled: !!code, staleTime: 30 * 60 * 1000, retry: false },
  );
  return code ? data : null;
}
